import React from 'react';
import { Button, ButtonProps } from '@mui/material';

const PrimaryButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({ children, sx, ...rest }, ref) => {
  return (
    <Button
      ref={ref}
      variant="contained"
      sx={{
        background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
        color: (theme) => theme.palette.primary.contrastText,
        borderRadius: (theme: any) => theme.radii?.medium ?? 10,
        paddingY: 1.25,
        boxShadow: '0 8px 24px rgba(37,99,235,0.24)',
        textTransform: 'none',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 12px 36px rgba(37,99,235,0.3)',
        },
        transition: 'all 220ms cubic-bezier(.2,.9,.2,1)',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
});

PrimaryButton.displayName = 'PrimaryButton';

export default PrimaryButton;
